import { gql } from 'graphql-tag';

export const getSectionTagsQuery = gql`
  query getSectionTags($id: ID!) {
    book_section(id: $id) {
      id
      tags {
        id
        text
      }
    }
  }
`;

export const getCommunityTagsQuery = gql`
  query getCommunityTags($id: ID!) {
    community(id: $id) {
      id
      tags {
        id
        text
      }
    }
  }
`;